const SET_DAY = 'directOrderRecurring/SET_DAY';

export default {
  SET_DAY,
};
